
import React from "react";

const BenneTypesCard: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8">
      <h3 className="text-xl font-bold text-fabre-gray mb-4">Types de bennes proposées</h3>
      <ul className="space-y-3">
        <li className="flex items-start">
          <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
          <span>Bennes ouvertes de 8 à 30 m³</span>
        </li>
        <li className="flex items-start">
          <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
          <span>Bennes fermées pour les déchets sensibles</span>
        </li>
        <li className="flex items-start">
          <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
          <span>Compacteurs pour les grands volumes</span>
        </li>
        <li className="flex items-start">
          <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
          <span>Bacs roulants pour les petits volumes</span>
        </li>
      </ul>

      <div className="mt-8">
        <h3 className="text-xl font-bold text-fabre-gray mb-4">Types de déchets acceptés</h3>
        <ul className="space-y-3">
          <li className="flex items-start">
            <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
            <span>Déchets industriels non dangereux</span>
          </li>
          <li className="flex items-start">
            <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
            <span>Gravats et déchets de chantier</span>
          </li>
          <li className="flex items-start">
            <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
            <span>Déchets verts</span>
          </li>
          <li className="flex items-start">
            <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-fabre-green text-white mr-3">•</span>
            <span>Métaux et ferrailles</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BenneTypesCard;
